import React, { useEffect, useState } from 'react'
import useHttp from '../../../hooks/use-http'
import CONSTANTS from '../../../util/constant/CONSTANTS'
import { Button, Card, Col, Form, Input, Row, Switch } from 'antd'
import moment from 'moment'
import Heading from '../../../component/common/Heading'

const Config = () => {
    const [appConfig, setAppConfig] = useState({})
    const [refresh, setRefresh] = useState(false)
    const api = useHttp()

    // console.log(appConfig);




    const submitHandler = (value) => {
        const payload = {
            androidVersionCode: value?.androidVersionCode,
            iosVersionCode: value?.iosVersionCode,
            appInMaintenance: value?.appInMaintenance,
            forceUpdate: value?.forceUpdate,
            softUpdate: value?.softUpdate,
        }
        // console.log(payload);


        const SET_APPCONFIG_API = { ...CONSTANTS.API.Config.update }
        SET_APPCONFIG_API.endpoint = SET_APPCONFIG_API.endpoint.replace(':id', appConfig?.id)
        api.sendRequest(SET_APPCONFIG_API, () => {
            setRefresh(prev => !prev)
        }, payload, 'Configuration Upadated Successfully!!!')
    }

    useEffect(() => {
        const GET_CONFIG_DATA_API = { ...CONSTANTS.API.Config.getAll }

        api.sendRequest(GET_CONFIG_DATA_API, (res) => {
            setAppConfig(res?.data?.rows[0]);
        })
    }, [refresh])

    const [form] = Form.useForm();
    form.setFieldsValue(appConfig)
    return (
        <>
            <Card className="my-5">
                <Heading>
                    App Config
                </Heading>
                <Form className='my-5' onFinish={submitHandler} form={form}>

                    {/* Android & IOSVersion */}
                    <Row>
                        <Col span={8}>
                            <p className="text-xl mt-1">
                                Android Version
                            </p></Col>
                        <Col>
                            <Form.Item name='androidVersionCode' id="androidVersionCode"  >
                                <Input type="text" onChange={(e) => {
                                    // console.log(+e.target.value);
                                    setAppConfig(prev => {
                                        return {
                                            ...prev,
                                            androidVersionCode: e.target.value
                                        }
                                    })
                                }} />

                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            <p className="text-xl mt-1">
                                IOS Version
                            </p></Col>
                        <Col>
                            <Form.Item name='iosVersionCode' id="iosVersionCode"  >
                                <Input type="text" onChange={(e) => {
                                    // console.log(+e.target.value);
                                    setAppConfig(prev => {
                                        return {
                                            ...prev,
                                            iosVersionCode: e.target.value
                                        }
                                    })
                                }} />

                            </Form.Item>
                        </Col>
                    </Row>



                    {/* Maintanance */}
                    <Row>
                        <Col span={8}>
                            <p className="text-xl mt-1">
                                App Under Maintanance
                            </p></Col>
                        <Col>
                            <Form.Item name='appInMaintenance' id="appInMaintenance" >
                                <Switch
                                    className="mt-2"
                                    checked={appConfig.appInMaintenance}
                                    onChange={(value) => {
                                        setAppConfig(prev => {
                                            return {
                                                ...prev,
                                                appInMaintenance: value
                                            }
                                        })
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* Soft Update */}
                    <Row>
                        <Col span={8}>
                            <p className="text-xl mt-1">
                                App Soft Update
                            </p></Col>
                        <Col>
                            <Form.Item name='softUpdate' id="softUpdate" >
                                <Switch
                                    className="mt-2"
                                    checked={appConfig.softUpdate}
                                    onChange={(value) => {
                                        setAppConfig(prev => {
                                            return {
                                                ...prev,
                                                softUpdate: value
                                            }
                                        })
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* Force Update */}
                    <Row>
                        <Col span={8}>
                            <p className="text-xl mt-1">
                                App Force Update
                            </p></Col>
                        <Col>
                            <Form.Item name='forceUpdate' id="forceUpdate" >
                                <Switch
                                    className="mt-2"
                                    checked={appConfig.forceUpdate}
                                    onChange={(value) => {
                                        setAppConfig(prev => {
                                            return {
                                                ...prev,
                                                forceUpdate: value
                                            }
                                        })
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>


                    <p>
                        Last Updated on {moment.utc(appConfig?.updatedAt).local().format('DD MMM, YYYY')} {moment.utc(appConfig?.updatedAt).local().format('hh:mm A')}
                    </p>

                    <Form.Item

                    >
                        <Button className='mt-2' type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>

            </Card>


        </>
    )
}

export default Config